import { useState } from "react";
import { Printer } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BETA_TERMS, BETA_TERMS_VERSION } from "@/lib/betaTerms";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Spinner } from "@/components/States";
import ElmMark from "@/components/ElmMark";

export default function BetaTermsGate() {
  const { user, logout, refreshUser } = useAuth();
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try { await api.post("/auth/accept-beta-terms"); toast.success("Thanks — welcome to the beta"); await refreshUser(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-background" data-testid="beta-terms-gate">
      <div className="mx-auto max-w-3xl px-6 py-10 md:py-16">
        <div className="mb-8 flex items-center justify-between print:hidden"><ElmMark /><Button variant="ghost" size="sm" onClick={() => window.print()} data-testid="beta-terms-print"><Printer className="mr-1.5 h-4 w-4" />Print</Button></div>
        <p className="eyebrow">Private beta · v{BETA_TERMS_VERSION}</p>
        <h1 className="page-title mt-2" data-testid="beta-terms-title">{BETA_TERMS.title}</h1>
        <p className="mt-4 text-sm text-muted-foreground">{BETA_TERMS.intro}</p>
        <div className="mt-8 space-y-5">
          {BETA_TERMS.sections.map(([h, body]) => (
            <section key={h}><h2 className="text-base font-semibold">{h}</h2><p className="mt-1 text-sm leading-relaxed text-muted-foreground">{body}</p></section>
          ))}
        </div>
        <p className="mt-8 text-sm">{BETA_TERMS.closing}</p>
        <div className="mt-8 rounded-xl border bg-card p-5 print:hidden">
          <label className="flex items-start gap-3 text-sm"><Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} className="mt-0.5" data-testid="beta-terms-agree" /><span>I, <strong>{user.name || user.email}</strong>, have read and accept the Private Beta Agreement on behalf of {user.workspace?.name || "my company"}.</span></label>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <Button className="rounded-full" disabled={!agree || busy} onClick={accept} data-testid="beta-terms-accept">{busy ? <Spinner /> : "Accept and continue"}</Button>
            <button type="button" className="text-xs text-muted-foreground underline-offset-4 hover:underline" onClick={logout} data-testid="beta-terms-signout">Not now — sign out</button>
          </div>
        </div>
      </div>
    </div>
  );
}
